import estilos from "./ProjetosDestaque.module.css";
import { projetos } from "../../data/projetos";

const ProjetosDestaque = () => {
  return (
    <section id="projetos" className={estilos.secao}>
      <span className={estilos.etiqueta}>// Projetos em Destaque</span>
      <h2 className={estilos.titulo}>Projetos</h2>

      <div className={estilos.listaProjetos}>
        {projetos.map((projeto) => (
          <article key={projeto.id} className={estilos.card}>
            <div className={estilos.cardCabecalho}>
              <span className={estilos.emoji}>{projeto.emoji}</span>
              <h3 className={estilos.cardTitulo}>{projeto.nome}</h3>
            </div>

            <p className={estilos.cardDescricao}>{projeto.descricaoTecnica}</p>

            <div className={estilos.secaoInterna}>
              <p className={estilos.secaoInternaTitulo}>Tecnologias</p>
              <div className={estilos.tecnologias}>
                {projeto.tecnologias.map((tech) => (
                  <span key={tech} className={estilos.tecnologia}>{tech}</span>
                ))}
              </div>
            </div>

            <div className={estilos.secaoInterna}>
              <p className={estilos.secaoInternaTitulo}>Desafios</p>
              <ul className={estilos.desafios}>
                {projeto.desafios.map((desafio) => (
                  <li key={desafio} className={estilos.desafio}>{desafio}</li>
                ))}
              </ul>
            </div>

            <div className={estilos.cardRodape}>
              <a href="#" className={estilos.botaoVer}>
                Ver Projeto
                <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ProjetosDestaque;
